//React
import React from "react";

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as myProfileAction from '../action/myProfileAction';
import * as settingAction from '../action/settingAction';

import Button from '@material-ui/core/Button';

//Material-ui
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';



import PartPageTitle from './PartPageTitle';
//Dialog
import DialogConfirm from './DialogConfirm';
//Icon



class Comp extends React.Component {
  constructor(props) {
		super(props);

    this.state = {
      newLoginId: '',
      newLoginIdError: null,
      newLoginIdSaveDialog: false,
    }
	}

  componentDidMount() {
    document.title = 'ログインIDの変更 - パートナーズ';
  }

  _newLoginIdEdit(value, overlap) {
    this.setState({ newLoginId: value});
  	let errorComment;

    if (value.length < 6 || value.length > 30) {
  		errorComment = '6～30文字で入力してください';
  	}
  	else if (value.match(/^[a-zA-Z0-9-_.]+$/) == null) {
  		errorComment = '入力できない文字が含まれています';
  	}
  	if (errorComment) {
  		this.setState({newLoginIdError: errorComment});
  	}
  	else {
      this.setState({newLoginIdError: null});
  	}
  };

  async _newLoginIdSaveCheck() {
    await this._newLoginIdEdit(this.state.newLoginId, true);
    if (this.state.newLoginIdError === null) {
      this.setState({newLoginIdSaveDialog: true});
    }
  }

  _newLoginIdSave() {
    this.setState({newLoginIdSaveDialog: false});
    this.props.settingLoginIdEdit(this.state.newLoginId, () => {

    });

  }


  render() {

    return (
      <div>
        <PartPageTitle
          title={'ログインIDの変更'}
          onback={ '/setting/' }
        />

        <div style={{maxWidth:'400px', margin:'auto'}}>
          <div style={{padding:'10px'}}>
            <h3 align='center'>新しいログインIDを入力</h3>
            <div>
              英数6～30文字
              <input
                type="text"
                value={ this.state.newLoginId }
                style={{fontSize:'1.2em'}}
                className="input_blue round12"
                onChange={ (e) => this._newLoginIdEdit(e.target.value) }
              />
              <div style={{color:'red'}}>{this.state.newLoginIdError}</div>
            </div>
          </div>


          <div align='center' style={{padding:'10px'}}>
            <Button
              variant="contained"
              color="primary"
              style={{minWidth:'240px'}}
              onClick={ () => this._newLoginIdSaveCheck() }
              disabled={ (this.state.newLoginId && !this.state.newLoginIdError) ? false : true }
            >
              <span style={{fontSize:'1.4em'}}>変更する</span>
            </Button>
          </div>
        </div>

        <DialogConfirm
          open={ this.state.newLoginIdSaveDialog }
          title={'ログインIDの変更'}
          content={(
            <div>
              <div>ログインIDを変更してもいいですか？</div>
            </div>
          )}
          apply={ () => this._newLoginIdSave() }
          close={ () => this.setState({newLoginIdSaveDialog: false}) }
        />

        <Snackbar
          open={this.state.saveSnackVisible}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          autoHideDuration={3000}
          onClose={ () => this.setState({saveSnackVisible: false})}
        >
          <MuiAlert severity="success" elevation={6} variant="filled">保存しました</MuiAlert>
        </Snackbar>

      </div>
    )

  }
}


const mapStateToProps = (state) => {
	return {
    my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...myProfileAction,
    ...settingAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
